<div class="data-table h-100 d-flex flex-column" [class.collapsed]="collapsed">
  @if (loading) {
    <div class="h-100 w-100 position-absolute">
      <div class="row h-100 m-3">
        <div
          class="col-12 text-center d-flex align-items-center justify-content-center"
        >
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">{{ 'common.loading' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  }
  @if (
    configuration.title ||
    configuration.pagination$ ||
    configuration.headerFilters ||
    configuration?.addAction ||
    configuration.massActions?.length ||
    configuration.additionalActions?.length ||
    (configuration.singleActions?.length &&
      configuration.actionsLocation === DataTableActionsLocation.TOP)
  ) {
    <div class="data-table-header">
      @let pagination = configuration.pagination$ | async;

      <div class="title">
        <span
          (click)="collapse()"
          [class.cursor-pointer]="configuration.collapsable"
        >
          @if (configuration.collapsable) {
            <i
              class="fa-light"
              [ngClass]="collapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            ></i>
          }
          {{ configuration.title | translate }}
        </span>
        @if (configuration.rowCount) {
          <span>{{ '(' + (rows$ | async)?.length + ')' }}</span>
        }
        @if (pagination) {
          <span
            >[{{ selectedRows.length }}/{{
              pagination.totalCount ?? '?'
            }}]</span
          >
        }
        <ng-template
          *ngTemplateOutlet="
            configuration.titleFilters;
            context: {
              selectedRows: [],
              totalCount: pagination?.totalCount ?? 0,
              pageSize: 30,
            }
          "
        >
        </ng-template>
      </div>
      <div class="header-filters mt-3 collapsable">
        <ng-template
          *ngTemplateOutlet="
            configuration.headerFilters;
            context: {
              selectedRows: [],
              totalCount: pagination?.totalCount ?? 0,
              pageSize: 30,
            }
          "
        >
        </ng-template>
      </div>
      <div class="actions mb-3 d-flex flex-row collapsable">
        <div>
          @if (configuration.addAction) {
            <app-data-table-nestable-actions
              [button]="configuration.addAction"
              [rows]="[]"
            >
            </app-data-table-nestable-actions>
          }
          @if (configuration.actionsLocation === DataTableActionsLocation.TOP) {
            @for (button of configuration.singleActions; track button) {
              <app-data-table-nestable-actions
                [button]="button"
                type="single"
                [rows]="selectedRows"
              >
              </app-data-table-nestable-actions>
            }
          }
          @for (button of configuration.massActions; track button) {
            <app-data-table-nestable-actions
              [button]="button"
              [rows]="selectedRows"
            >
            </app-data-table-nestable-actions>
          }
        </div>
        <div class="flex-fill"></div>
        <div>
          @for (button of configuration.additionalActions; track button) {
            <app-data-table-nestable-actions
              [button]="button"
              [rows]="selectedRows"
            >
            </app-data-table-nestable-actions>
          }
        </div>
      </div>
    </div>
  }
  <div
    class="data-table-content flex-fill overflow-auto collapsable"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    [scrollWindow]="false"
    (scrolled)="configuration.scrollBottom?.()"
  >
    <table
      class="table table-hover mb-0"
      [ngClass]="configuration.tableClasses"
    >
      <thead>
        <tr [ngClass]="configuration.tableHeadClasses">
          @if (configuration.selectionMode === DataTableSelectionType.MULTI) {
            <th
              [ngClass]="configuration.tableCellClasses"
              class="border-0 multi-select"
            >
              <div class="form-check form-check-lg d-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="checkAllStatus"
                  (change)="toggleAllCheckboxes($event)"
                />
              </div>
            </th>
          }
          @for (column of configuration.columns; track $index) {
            <th
              *appRequirePermission="column.permission"
              [ngClass]="configuration.tableCellClasses"
              class="border-0"
            >
              <div
                class="text-nowrap fw-bold"
                [attr.data-cy]="(column.label | translate) + '-label'"
              >
                {{ (column.label | translate) ?? ' ' }}
              </div>
              @if (column.filter) {
                <div class="filter mt-1">
                  <!-- Filter type TEXT-->
                  @if (column.filter.type === DataTableFilterType.TEXT) {
                    <input
                      type="text"
                      class="w-100 form-control py-1"
                      [ngModel]="
                        column.filter.subject?.value ?? column.filter.signal?.()
                      "
                      [placeholder]="
                        column.filter.placeholder ?? '' | translate
                      "
                      [attr.data-cy]="(column.label | translate) + '-input'"
                      (ngModelChange)="
                        column.filter.subject?.next($event) ??
                          column.filter.signal?.set($event)
                      "
                    />
                  }
                  <!-- Filter type SELECT-->
                  @if (column.filter.type === DataTableFilterType.SELECT) {
                    <app-select
                      size="sm"
                      [header]="column.filter.search ? true : false"
                      [placeholder]="
                        column.filter.placeholder ?? 'common.placeholders.all'
                      "
                      [selected]="
                        column.filter.subject
                          ? column.filter.subject.value
                          : column.filter.signal?.()
                      "
                      [attr.data-cy]="(column.label | translate) + '-select'"
                      (changed)="
                        column.filter.subject?.next($event) ??
                          column.filter.signal?.set($event)
                      "
                    >
                      <app-select-option
                        [value]="null"
                        [label]="
                          column.filter.placeholder ?? 'common.placeholders.all'
                            | translate
                        "
                      />
                      @for (
                        option of column.filter.options | async;
                        track option
                      ) {
                        <app-select-option
                          [value]="
                            column.filter.idProperty
                              ? option[column.filter.idProperty]
                              : option
                          "
                          [label]="
                            (column.filter.translationPrefix || '') +
                              (column.filter.nameProperty
                                ? option[column.filter.nameProperty]
                                : option) | translate
                          "
                        />
                      }
                    </app-select>
                  }
                  <!-- Filter type SELECTMULTIPLE-->
                  @if (
                    column.filter.type === DataTableFilterType.SELECTMULTIPLE &&
                    !column.filter?.groupByAction
                  ) {
                    <app-multi-select
                      size="sm"
                      [placeholder]="column.filter.placeholder | translate"
                      [attr.data-cy]="
                        (column.label | translate) + '-multi-select'
                      "
                      [selected]="
                        column.filter.subject?.value ?? column.filter.signal?.()
                      "
                      [footer]="true"
                      [header]="column.filter.search ? true : false"
                      (changed)="
                        column.filter.subject?.next($event) ??
                          column.filter.signal?.set($event)
                      "
                    >
                      @for (
                        option of column.filter.options | async;
                        track option
                      ) {
                        <app-multi-select-checkbox
                          class="d-flex fw-normal"
                          [label]="
                            (column.filter.translationPrefix || '') +
                              (column.filter.nameProperty
                                ? option[column.filter.nameProperty]
                                : option) | translate
                          "
                          [value]="
                            column.filter.idProperty
                              ? option[column.filter.idProperty]
                              : option
                          "
                        />
                      }
                    </app-multi-select>
                  }
                  <!-- Filter type grouped SELECTMULTIPLE-->
                  @if (
                    column.filter.type === DataTableFilterType.SELECTMULTIPLE &&
                    column.filter?.groupByAction
                  ) {
                    <app-multi-select
                      size="sm"
                      [placeholder]="column.filter.placeholder | translate"
                      [attr.data-cy]="
                        (column.label | translate) + '-multi-select'
                      "
                      [footer]="true"
                      [selected]="
                        column.filter.subject?.value ?? column.filter.signal?.()
                      "
                      [header]="column.filter.search ? true : false"
                      (changed)="
                        applyFilter(
                          $event,
                          column.filter?.subject,
                          column.filter?.signal
                        )
                      "
                    >
                      @for (
                        group of column.filter.groupByAction(
                          column.filter.options | async
                        ) | keyvalue;
                        track group.key
                      ) {
                        <div class="group" appMultipleSelectGroup>
                          <app-multi-select-checkbox
                            class="d-flex"
                            [label]="group.key"
                            [value]="group.key"
                          />
                          @for (option of group.value; track option) {
                            <app-multi-select-checkbox
                              class="d-flex ms-4 fw-normal"
                              [label]="
                                (column.filter.translationPrefix || '') +
                                  (column.filter.nameProperty
                                    ? option[column.filter.nameProperty]
                                    : option) | translate
                              "
                              [value]="
                                column.filter.idProperty
                                  ? option[column.filter.idProperty]
                                  : option
                              "
                            />
                          }
                        </div>
                      }
                    </app-multi-select>
                  }
                  <!-- Filter type DATE-->
                  @if (column.filter.type === DataTableFilterType.DATE) {
                    <input
                      type="text"
                      class="w-100 form-control"
                      ngbDatepicker
                      #datePicker="ngbDatepicker"
                      [ngModel]="
                        column.filter.subject?.value ?? column.filter.signal?.()
                      "
                      [placeholder]="
                        column.filter.placeholder ?? '' | translate
                      "
                      [attr.data-cy]="(column.label | translate) + '-input'"
                      (ngModelChange)="
                        emitDate(
                          $event,
                          column.filter.subject,
                          column.filter.signal
                        )
                      "
                      (click)="datePicker.toggle()"
                    />
                  }
                  @if (column.filter.template) {
                    <ng-template *ngTemplateOutlet="column.filter.template">
                    </ng-template>
                  }
                </div>
              }
            </th>
          }
          @if (
            configuration.actionsLocation === DataTableActionsLocation.RIGHT &&
            (configuration.singleActions?.length ||
              configuration.footerActions?.length)
          ) {
            <th
              [ngClass]="
                configuration.tableCellClasses +
                ' ' +
                configuration.actionsClasses
              "
              class="border-0 actions"
            >
              <div class="fw-bold">{{ 'common.actions' | translate }}</div>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @if (rows$ | async; as rows) {
          @if (rows.length > 0) {
            @for (row of rows; track $index; let rowIndex = $index) {
              <tr
                [class.table-active]="!!checkboxes[rowIndex]"
                (dblclick)="openDetails($event, row)"
                (click)="rowClick($event, rowIndex)"
              >
                @if (
                  configuration.selectionMode === DataTableSelectionType.MULTI
                ) {
                  <td
                    [ngClass]="configuration.tableCellClasses"
                    class="align-middle"
                  >
                    <div class="form-check form-check-lg mb-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [(ngModel)]="checkboxes[rowIndex]"
                        (click)="rowClick($event, rowIndex)"
                      />
                    </div>
                  </td>
                }
                @for (
                  column of configuration.columns;
                  track column;
                  let columnIndex = $index
                ) {
                  <td
                    *appRequirePermission="column.permission"
                    class="caption"
                    [ngClass]="configuration.tableCellClasses"
                    [style]="column.customStyle"
                  >
                    <!--          Check if displaying property or template-->
                    @if (column.property || column.invoke) {
                      <!--            Check if property exists on object-->
                      @if (column.property && get(row, column.property)) {
                        <!--              Check for property type, so we choose correct display template-->
                        @if (
                          column.type === DataTableDataType.TEXT || !column.type
                        ) {
                          {{
                            column.translationPrefix
                              ? (column.translationPrefix +
                                  get(row, column.property) | translate)
                              : get(row, column.property)
                          }}
                        }
                        @if (column.type === DataTableDataType.DATETIME) {
                          {{
                            moment(get(row, column.property)).format(
                              MOMENT_DATE_TIME_FORMAT
                            )
                          }}
                        }
                        @if (column.type === DataTableDataType.DATE) {
                          {{
                            moment(get(row, column.property)).format(
                              MOMENT_DATE_FORMAT
                            )
                          }}
                        }
                      }
                      <!--            Invoke method instead of reading property (for reading properties and similar methods) -->
                      @if (
                        column.invoke &&
                        get(column.invoke.objectReference, column.invoke.name)
                      ) {
                        {{
                          invoke(
                            column.invoke.objectReference,
                            column.invoke.name,
                            column.invoke.args,
                            row
                          )
                        }}
                      }
                    } @else {
                      <ng-template
                        *ngTemplateOutlet="
                          column.propertyTemplate;
                          context: { row: row, index: rowIndex }
                        "
                      >
                      </ng-template>
                    }
                    <!--          If "property" is not set, we display propertyTemplate-->
                    @if (
                      columnIndex === 0 &&
                      (!configuration.actionsLocation ||
                        configuration.actionsLocation ===
                          DataTableActionsLocation.BOTTOM)
                    ) {
                      <div class="rowActions text-nowrap mt-1">
                        @for (
                          button of configuration.singleActions;
                          track button
                        ) {
                          <app-data-table-nestable-actions
                            [button]="button"
                            type="single"
                            [rows]="[row]"
                          >
                          </app-data-table-nestable-actions>
                        }
                      </div>
                    }
                  </td>
                }
                @if (
                  configuration.actionsLocation ===
                    DataTableActionsLocation.RIGHT &&
                  (configuration.singleActions?.length ||
                    configuration.footerActions?.length)
                ) {
                  <td
                    [ngClass]="
                      configuration.tableCellClasses +
                      ' ' +
                      configuration.actionsClasses
                    "
                    class="actions"
                  >
                    @for (button of configuration.singleActions; track button) {
                      <app-data-table-nestable-actions
                        [button]="button"
                        type="single"
                        [rows]="[row]"
                      >
                      </app-data-table-nestable-actions>
                    }
                  </td>
                }
              </tr>
              @if (configuration.extraRow) {
                <tr class="extraRow">
                  <td class="p-0" [colSpan]="getTableColSpan()">
                    <ng-template
                      *ngTemplateOutlet="
                        configuration.extraRow;
                        context: { row: row, index: rowIndex }
                      "
                    >
                    </ng-template>
                  </td>
                </tr>
              }
            }
          } @else {
            <tr>
              <td [attr.colspan]="getTableColSpan()">
                <p
                  class="text-center caption m-0"
                  translate="common.table.noData"
                ></p>
              </td>
            </tr>
          }
        }
        @if (hasFooterCells) {
          <tr>
            @if (configuration.selectionMode === DataTableSelectionType.MULTI) {
              <td></td>
            }
            @for (
              column of configuration.columns;
              track column;
              let columnIndex = $index
            ) {
              <td
                class="caption"
                [ngClass]="configuration.tableCellClasses"
                [style]="column.customStyle"
              >
                <ng-template *ngTemplateOutlet="column.footerTemplate">
                </ng-template>
              </td>
            }
            @if (
              configuration.actionsLocation ===
                DataTableActionsLocation.RIGHT &&
              (configuration.singleActions?.length ||
                configuration.footerActions?.length)
            ) {
              <td
                [ngClass]="
                  configuration.tableCellClasses +
                  ' ' +
                  configuration.actionsClasses
                "
                class="actions"
              >
                @for (button of configuration.footerActions; track button) {
                  <app-data-table-nestable-actions
                    [button]="button"
                    [rows]="[]"
                  >
                  </app-data-table-nestable-actions>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (
    !configuration.hidePagination && configuration.pagination$ | async;
    as pagination
  ) {
    <div class="data-table-footer pt-2 collapsable">
      @if (pagination !== null) {
        @if (pagination.totalCount > 0) {
          <div
            class="pagination-container d-flex justify-content-between align-items-center"
          >
            @let pageIndex = pagination.currentPageSettings.pageIndex;
            @let pageSize = pagination.collectionSize;

            <div class="d-flex align-items-center">
              <div>
                @if (configuration.dynamicPageSize) {
                  <span class="fw-bold me-1">
                    {{ 'common.table.itemsPerPage' | translate }}
                  </span>
                  <app-select
                    class="d-inline-block me-3"
                    [selected]="
                      pagination.currentPageSettings.sortSettings.pageSize
                    "
                    (changed)="pageSizeChange.emit($event)"
                  >
                    <app-select-option [value]="30" label="30" />
                    <app-select-option [value]="60" label="60" />
                    <app-select-option [value]="100" label="100" />
                  </app-select>
                }

                @let from = pageIndex * pageSize + 1;
                @let to = (pageIndex + 1) * pageSize;

                <span
                  class="fw-bold"
                  translate="common.table.pagination"
                  [translateParams]="{
                    from: from,
                    to: to > pagination.totalCount ? pagination.totalCount : to,
                    totalCount: pagination.totalCount,
                  }"
                ></span>
              </div>
            </div>

            @let page = pageIndex + 1;
            @let pagesLength = pagination.pagesSize;

            <ngb-pagination
              size="sm"
              [page]="page"
              [pageSize]="pageSize"
              [maxSize]="
                layoutService.mobileView() && pagesLength > 3
                  ? 3
                  : pagesLength > 6
                    ? 6
                    : pagesLength
              "
              [rotate]="true"
              [collectionSize]="
                pagesLength * pageSize < pagination.totalCount
                  ? (pagesLength + 1) * pageSize
                  : pagination.totalCount
              "
              [boundaryLinks]="true"
              [directionLinks]="true"
              (pageChange)="onPageChange($event)"
            >
            </ngb-pagination>
          </div>
        }
      }
    </div>
  }
</div>
